import { IOperation, ISetting } from '@/models/IFunctionality';
import { IRecords } from '@/models/IRecord';
import { slugify } from '@/utils/text-utils';
import { Chip } from '@destination/components';
import { FunctionalitySettingsDetail } from './FunctionalitySettingsDetail';
import ModelAttributeCard from '@components/model/details/ModelAttributeCard';

export interface IFunctionalitySettingsList {
  settings: ISetting[];
  operations: IOperation[];
  records: IRecords;
  'data-testid'?: string;
}

export function FunctionalitySettingsList({
  settings,
  operations,
  records,
  'data-testid': dataTestId
}: IFunctionalitySettingsList) {
  const titleComponent = (setting: ISetting) => (
    <div className="flex items-center w-full justify-between">
      <div className="tw-text-base w-1/4">{setting.name}</div>
      <div className="flex items-center w-3/4">
        <Chip label={setting.operation.$ref} />
      </div>
    </div>
  );

  return (
    <div data-testid={dataTestId}>
      {settings.map(setting => {
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={slugify(setting.name)}
            title={titleComponent(setting)}
          >
            <div className="p-3 bg-slate-50">
              <FunctionalitySettingsDetail
                setting={setting}
                operations={operations}
                records={records}
              />
            </div>
          </ModelAttributeCard>
        );
      })}
    </div>
  );
}
